import React from "react";
import classnames from "classnames";
interface IParams {
  hasDocument: boolean;
  markedAsNew?: boolean;
  typology: number
}

const TreeIcon: React.FC<IParams> = ({ hasDocument, markedAsNew , typology}) => {
  const getIconByType = (type?: number) => {
    if(type === undefined) return null;
    switch (type) {
      //none
      case 0:
      return "fas fa-file-alt"  // in generale  sqllite per default in "utilities"  typology: 0 
      //image
      case 1:
      return "fas fa-file-image"
      //pdf
      case 2:
      return "fas fa-file-pdf";
      //powerPoint
      case 3:
      return "fas fa-file-powerpoint";
      //video
      case 4:
      return "fas fa-file-video";
      //doc
      case 5:
      return "fas fa-file-word";
      //www
      case 6:
      return  "fas fa-external-link-alt";
      //audio
      case 7:
      return "fas fa-file-music";
      //excelly
      case 8:
      return "fas fa-file-excel";
      default:
        return  "fas fa-question";
    }
  }

  return (
    // ICONE FONTAWESOME
    <div className="w-100 h-100">
      <div className="odgIcon">
        {markedAsNew ? (
          <>
            <span
              className="fa-stack"
              style={{ fontSize: "10px", marginLeft: "-5px" }}
            >
              <i
                className={classnames(
                  hasDocument ? getIconByType(typology) : "fas fa-file",
                  "fa-stack-2x"
                )}
              ></i>
              <i
                className="fas fa-circle fa-stack-1x"
                style={{
                  color: "red",
                  marginTop: "8px",
                  marginLeft: "6px",
                  fontSize: "8px",
                }}
              ></i>
            </span>
          </>
        ) : (
          <i className={classnames(hasDocument ?  getIconByType(typology) : "fas fa-file")}
          ></i>
          )}
      </div>
    </div>
  );
};

export default TreeIcon;
